import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchContent } from "../lib/api";

const CMSContext = createContext(null);

export function CMSProvider({ children }) {
  const [cms, setCms] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = async () => {
    try {
      setLoading(true);
      const data = await fetchContent();
      setCms(data);
      setError(null);
    } catch (e) {
      setError(e?.message || "Failed to load content");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    reload();
  }, []);

  return (
    <CMSContext.Provider value={{ cms, loading, error, reload, setCms }}>
      {children}
    </CMSContext.Provider>
  );
}

export function useCMS() {
  const ctx = useContext(CMSContext);
  if (!ctx) throw new Error("useCMS must be inside CMSProvider");
  return ctx;
}

export function useSectionEnabled(key) {
  const { cms } = useCMS();
  if (!cms?.sectionsEnabled) return true;
  return cms.sectionsEnabled[key] !== false;
}
